// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__jmcdu","icon":"CloseButton_icon___yI47"};